import { createContext, Dispatch, SetStateAction } from "react"
import { noop } from "lodash-es"
import { AddAchFormValues } from "~/app/pages/payments/types"

export const BankDetailsContext = createContext<{
  bankDetails: AddAchFormValues | null
  setBankDetails: Dispatch<SetStateAction<AddAchFormValues | null>>
}>({
  bankDetails: null,
  setBankDetails: noop,
})
